
  <mat-toolbar color="primary">
    <div fxShow="true" fxHide.gt-sm="true">
      <button mat-icon-button (click)="sidenav.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <img style="height: 50px;" src="assets/img/logonew.svg">
    <span class="example-spacer"></span>
    <span>GP Automazioni</span>
    <span class="example-spacer"></span>

    <div fxShow="true" fxHide.lt-md="true">
      <!-- The following menu items will be hidden on both SM and XS screen sizes -->
      <a routerLink="/home" routerLinkActive="active" mat-button>Home</a>
      <a routerLink="/chi-siamo" routerLinkActive="active" mat-button>Chi siamo</a>
      <a href="/attivita" mat-button>Attività</a>
      <!--<a href="#" mat-button>Certificazioni e risorse</a>
      <a href="#" mat-button>Notizie</a>-->
      <a href="/contatti" mat-button>Contatti</a>
    </div>
  </mat-toolbar>

  <mat-sidenav-container fxFlexFill class="example-container">
    <mat-sidenav #sidenav fxLayout="column">
      <div fxLayout="column">
        <a routerLink="/home" routerLinkActive="active" (click)="sidenav.toggle()" mat-button>Home</a>
        <a routerLink="/chi-siamo" routerLinkActive="active" (click)="sidenav.toggle()" mat-button>Chi siamo</a>
        <a href="/attivita" mat-button>Attività</a>
        <!--<a href="#" mat-button>Certificazioni e risorse</a>
        <a href="#" mat-button>Notizie</a>-->
        <a href="/contatti" mat-button>Contatti</a>
      </div>
    </mat-sidenav>
    <mat-sidenav-content fxFlexFill>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>

